import { upcomingEvents } from '../../../data/events';
import { EventCard } from './EventCard';

export function UpcomingEvents() {
  return (
    <section id="upcoming" className="bg-page py-section">
      <div className="mx-auto max-w-content px-6 md:px-16">
        <p className="font-ui text-[0.8rem] font-semibold uppercase tracking-[0.12em] text-action">2026 season</p>
        <h2 className="mt-2.5 font-display text-4xl font-bold tracking-tight text-fg-primary md:text-[2.5rem]">
          Upcoming Events
        </h2>
        <p className="mt-2 max-w-xl font-body text-lg text-fg-muted">
          Our flagship conferences and awards for the year ahead.
        </p>

        <div className="mt-10 grid max-w-[820px] gap-7 md:grid-cols-2">
          {upcomingEvents.map((event) => (
            <EventCard key={event.name} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
}

